import type {
    EnhancedLocation,
    LocationIdType,
    LocationEntityType,
    LocationSourceType,
} from 'owa-graph-schema';
import { logUsage } from 'owa-analytics';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

export default function getWorkLocationDetails(
    isOfficeLocation: boolean,
    personalLocation: EnhancedLocation
): {
    displayName: string;
    annotation: string;
    postalAddress: {
        street: string;
        city: string;
        state: string;
        country: string;
        postalCode: string;
        postOfficeBox: string;
    };
    id: string;
    idType: LocationIdType;
    locationUri: string;
    locationType: LocationEntityType;
    locationSource: LocationSourceType;
    // Coordinates are always set to 0 to keep compliance working
    coordinates: {
        longitude: number;
        latitude: number;
        accuracy: number;
        altitude: number;
        altitudeAccuracy: number;
    };
} | null {
    const isNotDefaultOption = personalLocation?.Id;

    let annotation = '';
    if (personalLocation?.DisplayName?.toLowerCase()?.includes('neighborhood')) {
        annotation = 'client modified a neighborhood - getWorkLocationDetails';

        logUsage('PlacesUpdatedNeighborhoodAsBuilding', getModuleContextMailboxInfo());
    }

    return isOfficeLocation && isNotDefaultOption
        ? {
              displayName: personalLocation?.DisplayName || 'undefined',
              annotation, // this place can be use to add the information of hiding location setting
              postalAddress: {
                  street: '',
                  city: '',
                  state: '',
                  country: '',
                  postalCode: '',
                  postOfficeBox: '',
              },
              id: personalLocation?.Id || '',
              idType: 'Directory' as LocationIdType,
              locationUri: '',
              locationType: 'Building' as LocationEntityType,
              locationSource: 'Resource' as LocationSourceType,
              // Coordinates are always set to 0 to keep compliance working
              coordinates: {
                  longitude: 0,
                  latitude: 0,
                  accuracy: 0,
                  altitude: 0,
                  altitudeAccuracy: 0,
              },
          }
        : null;
}
